import React from 'react'
import cx from 'classnames'
import { t } from 'ttag'
import { Button } from 'components/shared/Button/Button'
import { Modal } from 'components/shared/Modal/Modal'
import { getInterestScoreLevel, getPersonalityScoreLevel } from '../../utils'
import styles from './TalentAreaInfoModal.module.scss'

const ScoreRing = ({ score }) => {
  const radius = 18
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (score / 100) * circumference

  return (
    <div className={styles.scoreRing} aria-hidden="true">
      <svg viewBox="0 0 44 44">
        <circle
          className={styles.scoreRingTrack}
          cx="22"
          cy="22"
          r={radius}
          fill="none"
        />
        <circle
          className={styles.scoreRingFill}
          cx="22"
          cy="22"
          r={radius}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          transform="rotate(-90 22 22)"
        />
      </svg>
      <span className={styles.scoreRingValue}>{score}</span>
    </div>
  )
}

const ScoreBox = ({ label, score, level }) => (
  <div className={cx(styles.scoreBox, styles[`scoreBox_${level}`])}>
    <div className={styles.scoreBoxLabel}>{label}</div>
    <div className={styles.scoreBoxValue}>{score}</div>
    <div className={styles.scoreBoxTrack}>
      <div className={styles.scoreBoxFill} style={{ width: `${score}%` }} />
    </div>
  </div>
)

export const TalentAreaInfoModal = ({ talent, onClose }) => {
  const isOpen = talent !== null

  if (!talent) {
    return null
  }

  const { area, description, personalityScore, interestScore, matchScore } =
    talent

  return (
    <Modal
      nestedModalEscapeCapture
      className={styles.modal}
      isOpen={isOpen}
      portalClassName={styles.portal}
      onClose={onClose}
    >
      <Modal.Content className={styles.content}>
        <div className={styles.card}>
          <div className={styles.header}>
            <h3 className={styles.title}>{area}</h3>
            <ScoreRing score={matchScore} />
          </div>
          {description ? (
            <p className={styles.description}>{description}</p>
          ) : null}
          <div className={styles.scoreBoxes}>
            <ScoreBox
              label={t`Personality`}
              level={getPersonalityScoreLevel(personalityScore)}
              score={personalityScore}
            />
            <ScoreBox
              label={t`Interest`}
              level={getInterestScoreLevel(interestScore)}
              score={interestScore}
            />
          </div>
          <div className={styles.actions}>
            <Button
              label={t`Close`}
              size="medium"
              variant="outlined"
              onClick={onClose}
            />
          </div>
        </div>
      </Modal.Content>
    </Modal>
  )
}
